/**
 * Quais números de página aparecem na paginação (15/09).
 *
 * Um botão por página quebrava o celular: 103 lançamentos são 9 páginas, 11
 * botões numa linha que não cabe, e a página INTEIRA passava a rolar de lado
 * (o relato veio com print). Com a primeira, a última e a vizinhança da atual,
 * a linha tem no máximo 7 números — cabe em 375px, com qualquer total.
 *
 * `'…'` marca o salto. Nunca é "…" para uma página só: pular um número que
 * caberia no lugar das reticências esconderia a página à toa.
 */
export type ItemDaPaginacao = number | '…';

export const paginasVisiveis = (atual: number, total: number, vizinhos = 1): ItemDaPaginacao[] => {
  if (total <= 0) return [];
  const a = Math.min(Math.max(atual, 1), total);
  const mostrar = new Set<number>([1, total]);
  for (let p = a - vizinhos; p <= a + vizinhos; p++) if (p >= 1 && p <= total) mostrar.add(p);
  // Nas pontas, completa a janela para a linha não encolher perto do começo/fim.
  if (a <= 3) for (let p = 2; p <= Math.min(total, 4); p++) mostrar.add(p);
  if (a >= total - 2) for (let p = Math.max(1, total - 3); p < total; p++) mostrar.add(p);

  const ordenadas = Array.from(mostrar).sort((x, y) => x - y);
  const out: ItemDaPaginacao[] = [];
  ordenadas.forEach((p, i) => {
    const anterior = ordenadas[i - 1];
    if (anterior !== undefined) {
      if (p - anterior === 2) out.push(anterior + 1); // salto de um só: mostra o número
      else if (p - anterior > 2) out.push('…');
    }
    out.push(p);
  });
  return out;
};
